import type { CSSProperties, ReactElement } from 'react';
import { Fragment, useRef, useState } from 'react';
import { useDebounceFn } from 'ahooks';
import { CloseCircleFilled, DeleteOutlined } from '@ant-design/icons';
import { type TAny } from '@flatbiz/utils';
import { IconWrapper } from '../icon-wrapper/icon-wrapper.jsx';

/** 删除节点，点击后会显示二次确认点击 */
export const DeleteNode = (props: {
  onDelete: () => void;
  /** 默认图标 */
  icon?: ReactElement;
  /** 确认图标 */
  confirmIcon?: ReactElement;
  /** 是否隐藏 */
  hidden?: boolean;
  style?: CSSProperties;
  className?: string;
}) => {
  const [status, setStatus] = useState(false);
  const timeoutRef = useRef<TAny>();

  const { run: onClick } = useDebounceFn(
    (event) => {
      event.stopPropagation();
      if (!status) {
        setStatus(true);
        timeoutRef.current = setTimeout(() => {
          setStatus(false);
        }, 3000);
      } else {
        clearTimeout(timeoutRef.current);
        setStatus(false);
        props.onDelete();
      }
    },
    { wait: 300, leading: true, trailing: false }
  );

  if (props.hidden) return <Fragment />;

  return (
    <IconWrapper
      className={props.className}
      style={props.style}
      icon={
        !status ? (
          props.icon ? (
            props.icon
          ) : (
            <DeleteOutlined />
          )
        ) : props.confirmIcon ? (
          props.confirmIcon
        ) : (
          <CloseCircleFilled style={{ color: 'red' }} />
        )
      }
      onClick={onClick}
      size="small"
    />
  );
};
